(function () {
	'use strict';

	a3_pilot_reports.factory('PaxInfoFactory', PaxInfoFactory);

	/**
	* @memberof PilotReports
	* @ngdoc factory
	* @name PaxInfoFactory
	* @description 
	*   Add, Update, Delete and Get Passenger information.
	* @ngInject
	*/
	function PaxInfoFactory(IndexedDBService, GenericService, localStorageMD5Service, SyncLogFactory, FlightFactory, CrewRouteFactory) {
		/**
		* Initialize the PaxInfo
		* @memberof PaxInfoFactory
		*/
		function PaxInfo() {
			this.Id = null;
			this.STD_utc = null;
			this.STD_lcl = null;
			this.STA_utc = null;
			this.STA_lcl = null;
			this.AcType = null;
			this.Registration = null;
			this.ConfigurationC = null;
			this.ConfigurationY = null;
			this.PaxTotalC = null;
			this.PaxTotalY = null;
			this.MarketingFlightNos = null;
			this.SupplementaryInfo = null;
			this.LastRun = null;
			this.Offpoints = [];
			this.ConnFlights = [];
			this.Seatmap = [];
			this.curtainRows = [];
			this.Statistics = {};

			this.GetId = GetId;
		}

		var objType = 'PaxInfo';
		var objCallback = PaxInfo;

		var service =
		{
			setPaxInfoToStorage: setPaxInfoToStorage,
			getPaxInfoFromStorage: getPaxInfoFromStorage,
			getPaxInfoList: getPaxInfoList,
			updatePaxInfo: updatePaxInfo,
			getAllPaxInfoFromStorage: getAllPaxInfoFromStorage,
			cleanOldDataPaxInfo: cleanOldDataPaxInfo,
			setMaskPaxInfoInRoute: setMaskPaxInfoInRoute
		}

		/**
		 * Overide default get Id
		 * @memberof PaxInfoFactory
		 * @returns {number} Id 
		 */
		function GetId() {
			return this.FlightId;
		}

		/**
 * Get Passenger information list for the selected flight
 * @memberof PaxInfoFactory
 * @param {number} flightId  The flight id 
 */
		function getPaxInfoList(flightId, callback) {
			var intFlightId = +flightId;
			var passengerList = [];
			var paxInfo = getPaxInfoFromStorage(intFlightId);
			if (paxInfo) {
				for (var i = 0; i < paxInfo.Seatmap.length; i++) {
					for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
						var passenger = paxInfo.Seatmap[i].Columns[j];
						if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
							passengerList.push(passenger);
						}
					}
				}
			}
			callback(passengerList);
		
		}

		/**
		 * Overide default get Id
		 * @memberof PaxInfoFactory
		 * @returns {number} Id 
		 */
		function GetStatistics(paxInfo) {
			var statistics = {};
			var syncLog = SyncLogFactory.getSyncLog();

			if (paxInfo && paxInfo.Seatmap) {

				paxInfo.curtainRows = [];

				var cabinType;
				for (var i = 0; i < paxInfo.Seatmap.length; i++) {
					for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {


						if (paxInfo.Seatmap[i].Columns[j].Cabin == 'J') {
							paxInfo.Seatmap[i].Columns[j].Cabin = 'Y';
						}

						if (cabinType == null) {
							cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
						}
						else if (cabinType != paxInfo.Seatmap[i].Columns[j].Cabin && paxInfo.Seatmap[i - 1] && paxInfo.Seatmap[i].Columns[j].Cabin != null) {
							cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
							paxInfo.curtainRows.push(paxInfo.Seatmap[i - 1].RowNo);
						}

					}
				}
			}

			return statistics;
		}

		/**
		 * Set Passenger informations
		 * @memberof PaxInfoFactory
		 * @param {Array} paxInfos  The passenger informations 
		 */
		function setPaxInfoToStorage(paxInfos) {
			if (paxInfos) {
				for (var i = 0; i < paxInfos.length; i++) {
					paxInfos[i].Statistics = GetStatistics(paxInfos[i]);
				}
			}
			GenericService.saveAll(paxInfos, objType, objCallback);
		}

		/**
		 * Set  a Passenger information list
		 * @memberof PaxInfoFactory
		 * @param {object} paxInfo  A passenger information list
		 */
		function savePaxInfoToStorage(paxInfo) {
			paxInfo.Statistics = GetStatistics(paxInfo);
			paxInfos[i].Seatmap = [];
			GenericService.save(paxInfo, objType, objCallback);
		}

		/**
		* Clean Old Data
		* @memberof PaxInfoFactory
		* @param {Array} pendingFlightIds FlightIds with pending reports
		*/
		function cleanOldDataPaxInfo(pendingFlightIds) {
			// get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
			var paxInfoFromStorage = getAllPaxInfoFromStorage();

			var oldDraftPaxInfo = paxInfoFromStorage.filter(function (item) {
				return pendingFlightIds.includes(item.FlightId);
			});
			GenericService.saveAll(oldDraftPaxInfo, objType, objCallback);

		}

		/**
		 * Get Passenger information for the selected flight
		 * @memberof PaxInfoFactory
		 * @param {Array} paxInfos  The passenger informations 
		 */
		function getPaxInfoFromStorage(flightId) {
			return GenericService.get(flightId, objType, objCallback);
		}

		//factory functions
		/**
		 * Update Passenger information
		 * @memberof PaxInfoFactory
		 * @param {object} paxInfo  The passenger informations 
		 */
		function updatePaxInfo(paxInfo) {
			if (paxInfo) {
				paxInfo.Statistics = GetStatistics(paxInfo);
				if (GenericService.get(paxInfo.FlightId, objType, objCallback))
					GenericService.save(paxInfo, objType, objCallback);
				else
					GenericService.add(paxInfo, objType, objCallback);
			}
		}

		/**
		 * Get Passenger information for the selected flights
		 * @memberof PaxInfoFactory
		 */
		function getAllPaxInfoFromStorage() {
			return GenericService.list(objType, objCallback);
		}

		/**
	   * Update Passenger information
	   * @memberof PaxInfoFactory
	   */
		function migratePaxInfo() {
			var lsPaxInfo = localStorageMD5Service.get(objType);
			if (lsPaxInfo && lsPaxInfo.length > 0) {
				IndexedDBService.addAll(objType, lsPaxInfo);
				localStorageMD5Service.remove(objType);
			}
		}

        /**
         * Hide pax name with condition
         * @memberof PaxInfoFactory
         */
        function setMaskPaxInfoInRoute(flightInfo){
            if(flightInfo && flightInfo.showPaxNames){
                var applyMask = false;
                var flights = CrewRouteFactory.getCrewRouteFlights(flightInfo.DutyNo, flightInfo.DutyDay, flightInfo.FlightDate);  
                flights = $filter('orderBy')(flights, 'ScheduledDeparture');
                var lastFlight = flights[flights.length - 1];
                if(moment.utc().diff(moment(lastFlight.ATA), 'hours') > 2){
                    //set mask
                    applyMask = true;

                } else if (moment.utc().diff(moment(lastFlight.ScheduledArrival), 'hours') > 4) {
                    //set mask
                    applyMask = true;

                }
                if(applyMask){
                    flights.forEach(function(flight){
                        flight.showPaxNames = false;
                        FlightFactory.updateFlight(flight)
                    });
                    flightIds = flights.map(function (item) {
                        return item.FlightId; // or Id (todo: check)
                    });

                    setMaskPaxInfoToStorage(flightIds);
                }
            }
        }

        function setMaskPaxInfoToStorage(flightIds) {
            getAllPaxInfoFromStorage(function (paxInfoResult) {
                var maskedPaxFlightList = [];
                maskedPaxFlightList = paxInfoResult.filter(function (item) {
                    return flightIds.includes(item.FlightId);
                });
                for (var i = 0; i < maskedPaxFlightList.length; i++) {
                    maskPaxNames(maskedPaxFlightList[i]);
                }
                var otherPaxInfo = paxInfoResult.filter(function (item) {
                    return !flightIds.includes(item.FlightId);
                });

				var newListPaxInfo = otherPaxInfo.concat(maskedPaxFlightList);
				GenericService.saveAll(newListPaxInfo, objType, objCallback);
            })
        }

        function maskPaxNames(pax){
            if (pax) {
                for (var i = 0; i < pax.Seatmap.length; i++) {
                    for (var j = 0; j < pax.Seatmap[i].Columns.length; j++) {
                        var passenger = pax.Seatmap[i].Columns[j];
                        if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
                            passenger.InfantSurname = passenger.InfantSurname ? "*****" : passenger.InfantSurname;
                            passenger.InfantGivenName = passenger.InfantGivenName ? "*****" : passenger.InfantGivenName;
                            passenger.Surname = passenger.Surname ? "*****" : passenger.Surname;
                            passenger.GivenName = passenger.GivenName ? "*****" : passenger.GivenName;
                        }
                    }
                }
            }
        }


		return service;
	}

})();
